import { render, staticRenderFns } from "./CargoLibraryView.vue?vue&type=template&id=08d0281c&scoped=true"
import script from "./CargoLibraryView.vue?vue&type=script&lang=ts"
export * from "./CargoLibraryView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d0281c",
  null
  
)

export default component.exports